import LottyLoading from './LottyLoading';

export default LottyLoading;
